<template>
    <div id="policies-index-page" class="dashboard-view">
        <div class="container">
            <section class="content">
                <h1>Policy Exceptions</h1>

                <div class="table-header" style="margin-bottom:20px;">
                    <div class="table-header__tabs"></div>
                    <div class="table-header__controls">
                        <router-link to="/policy-exceptions/create" class="table-header__controls__btn">New Exception</router-link>
                    </div>
                </div>

                <DataTable class="policies-data-table"
                           :dataUrl="dataUrl"
                           :displayId="false"
                           :key="tableRefreshKey"
                           :dataFormatter="formatData"
                           :sortable="true"
                           @actionTriggered="actionTriggered">

                    <template v-slot:empty>
                        No records found
                    </template>
                </DataTable>

            </section>
        </div>
    </div>
</template>

<script>
import DataTable from '@/components/global/DataTable.vue'
const endpoint = process.env.VUE_APP_API_BASE + '/policy-exceptions'
import axios from 'axios'

export default {
    name: 'PoliciesIndex',
    components: {
        DataTable
    },
    data: function() {
        return {
            dataUrl: endpoint,
            tableRefreshKey: null
        }
    },
    methods: {
        formatData(data) {
            const newData = []
            for (let obj of data) {
                const newObj = {}
                const columns = ['_id', 'user', 'createdAt']

                for (let key of columns) {
                    if (key.includes('At')) {
                        newObj[key] = {
                            'label': key,
                            'value': obj[key],
                            'display_type': 'date'
                        }
                    }
                    else if (key === 'user') {
                        newObj[key] = {
                            'label': key,
                            'value': obj[key],
                            'display_type': 'object'
                        }
                        newObj['labName'] = {
                            'label': 'Lab name',
                            'value': obj[key].name,
                            'display_type': 'text'
                        }
                    }
                    else {
                        newObj[key] = {
                            'label': key,
                            'value': obj[key],
                            'display_type': 'text'
                        }
                    }
                }

                const actions = {
                    'delete': `<i class="delete-user-action" title="Delete">Delete</i>`
                }
                newObj['actions'] = {
                    'label': '',
                    'value': actions,
                    'display_type': 'actions'
                }

                //const newObjOrdered = Object.assign({'image': ''}, newObj)
                newData.push(newObj)
            }
            return newData
        },
        actionTriggered(actionKey, identifier) {
            if (!identifier) {
                alert('Error occurred #89')
            }
            else if (actionKey == 'delete') {
                if (confirm('Are you sure you want to delete this exception?')) {
                    axios.delete(endpoint + '/' + identifier)
                        .then(response => {
                            if (response.data.success === true) {
                                this.tableRefreshKey = Date.now()
                            }
                            else {
                                alert('Error occurred')
                                console.log(response.data.data)
                            }
                        })
                        .catch(error => {
                            alert('Error occurred while deleting')
                            console.log(error)
                        })
                }
            }
        },
    }
}
</script>

<style lang="scss" scoped>
</style>
